import React, { useState } from 'react';
import SectionShell from '../SectionShell';
import useAutoplayIntroVideo from '../../hooks/useAutoplayIntroVideo';
import { useAuth } from '../../auth/AuthContext';

/**
 * Thomas Kutak Intro-Video — sits DIRECTLY AFTER the Hero slide, BEFORE
 * the Agenda. Full-bleed, autostarts (muted) the moment the slide enters
 * the viewport. First tap unmutes the audio; the following tap advances.
 *
 * Admin-Toggle (08/2026): section_visibility.introsAudio === false
 * ⇒ Video bleibt sichtbar, spielt aber komplett stumm ab.
 *
 * Poster-Fix (08/2026): Video ist initial unsichtbar (schwarz) — sobald
 * `playing`-Event feuert, wird es via CSS eingeblendet.
 */
const VIDEO_SRC = '/videos/thomas-intro.mp4';

export default function SectionThomasIntro() {
  const { user } = useAuth();
  const audioOn = (user && user.section_visibility && user.section_visibility.introsAudio !== false);
  const { videoRef, stageRef } = useAutoplayIntroVideo('thomas-intro', { forceMuted: !audioOn });
  const [visible, setVisible] = useState(false);

  return (
    <SectionShell
      id="thomas-intro"
      className="relative overflow-hidden"
      fullBleed
      centerContent
    >
      <div
        ref={stageRef}
        className="zert-video-stage"
        data-testid="thomas-intro-stage"
        style={{ background: '#000' }}
      >
        <div className="zert-video-frame" style={{ background: '#000' }}>
          <video
            ref={videoRef}
            className="zert-video-el"
            playsInline
            autoPlay
            muted={!audioOn}
            preload="auto"
            onPlaying={() => setVisible(true)}
            data-testid="thomas-intro-video"
            style={{
              opacity: visible ? 1 : 0,
              transition: 'opacity 240ms ease',
            }}
          >
            <source src={VIDEO_SRC} type="video/mp4" />
          </video>
        </div>
      </div>
    </SectionShell>
  );
}
